import axios from 'axios';

export async function getVesselSanctions(imo) {
    try {
        const sanctions = await axios({
            method: 'GET',
            url: `/api/v2/vessels/${imo}/compliance`,
            withCredentials: true,
        });

        return sanctions.data || sanctions.response.data;
    } catch (e) {
        console.error('e');
        return [];
    }
}

export function updateVesselCompliance(imo, complianceId, type, data) {
    return axios({
        method: 'PUT',
        url: `/api/v2/vessels/${imo}/compliance/admin/${type}`,
        withCredentials: true,
        data: {
            [type]: data,
            sanctionsId: complianceId,
        },
    }).then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/sanctions.js